import React from "react";
import { Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { colors } from "../config/colors";
import { BORDER_RADIUS_SM } from "../config/styles";

const SkeletonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  border: `1px solid ${colors.storkeLight}`,
  borderRadius: BORDER_RADIUS_SM,
  padding: "16px",
  gap: "8px",
}));

/**
 * TableSkeletonLoader Component
 * 
 * Reusable skeleton loader for table lists. Prevents layout shift during loading.
 * Use this for consistent loading UI across all table views (SmartPlans, PaymentLinks, etc).
 * 
 * @param {number} rowCount - Number of skeleton rows to display (default: 5)
 * @param {number} rowHeight - Height of each skeleton row in pixels (default: 52)
 */
export const TableSkeletonLoader = ({ rowCount = 5, rowHeight = 52 }) => {
  return (
    <SkeletonContainer>
      {Array.from({ length: rowCount }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width="100%"
          height={rowHeight}
          style={{
            marginBottom: index < rowCount - 1 ? "0px" : "0px",
          }}
        />
      ))}
    </SkeletonContainer>
  );
};

TableSkeletonLoader.propTypes = {
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
};

export default TableSkeletonLoader;
